import { useEffect } from 'react'

type PublicPageHeadProps = {
  title: string
  description?: string | null
  imageUrl?: string | null
  canonicalPath?: string
  canonicalUrl?: string | null
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function upsertLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    document.head.appendChild(el)
  }
  el.href = href
}

export function PublicPageHead({
  title,
  description,
  imageUrl,
  canonicalPath,
  canonicalUrl,
}: PublicPageHeadProps) {
  useEffect(() => {
    document.title = title
    const desc = (description || title).trim()
    upsertMeta('name', 'description', desc)
    upsertMeta('property', 'og:title', title)
    upsertMeta('property', 'og:description', desc)
    const canonical =
      (canonicalUrl || '').trim() ||
      (canonicalPath ? `${window.location.origin}${canonicalPath}` : '')
    if (canonical) {
      upsertLink('canonical', canonical)
      upsertMeta('property', 'og:url', canonical)
    }
    if (imageUrl) {
      upsertMeta('property', 'og:image', imageUrl)
    }
  }, [title, description, imageUrl, canonicalPath, canonicalUrl])

  return null
}
